import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ViewController } from 'ionic-angular';
import { PopupPage } from '../../popup/popup';
import { ShowmorearticlesPage } from '../showmorearticles/showmorearticles';
import { ShowonearticlePage } from '../showonearticle/showonearticle';
import { GN } from '../../../gn';

/**
 * Generated class for the SearcharticlesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-searcharticles',
  templateUrl: 'searcharticles.html',
})
export class SearcharticlesPage {
  selectedEmplName = ''
  selectedEmplIds = ''
  classData = []
  article: string = ''
  articleid = -1
  artObj = []
  artClassObjs: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public popoverCtrl: PopoverController, public gn: GN, public viewCtrl: ViewController) {
    this.selectedEmplName = '- Изберете -'
    this.article = '- Изберете -'

    var _that = this
    this.gn._Post('/api/getmebelviclass', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
      _that.classData = _data
    })

    // this.classData.push({ id: 1, name: 'Клуб маси' })
    // this.classData.push({ id: 2, name: 'Закачалки' })
    // this.classData.push({ id: 3, name: 'Ормари' })
    // this.classData.push({ id: 3, name: 'Аголни гарнитури' })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SearcharticlesPage');
  }

  pickPrimaryClassification(_ev) {
    this.artClassObjs = []
    if (this.classData.length > 0) {
      var _that = this
      let popover = this.popoverCtrl.create(PopupPage, {
        type: 'PrimaryClassification', selected: '', arrayData: this.classData, callback: function (_text, _ids) {
          _that.selectedEmplName = _text
          _that.selectedEmplIds = _ids
          //var lastArticle;
          //_that.gn._Post('/api/getmebelviarticlesbyclass', { class: _that.gn.crypt(_that.selectedEmplIds), cid: _that.gn.crypt(_that.gn.user.ClientId), uid: _that.gn.crypt(_that.gn.user.UserId) }, function (_data) {
          //_data.length
          //for (var a = 0; a < _data.length; a++) {
          //if (_data[a].acName != lastArticle) {
          //_that.artClassObjs.push({ ident: _data[a].acIdent, name: _data[a].acName, descr: _data[a].acDescr, price: _data[a].price, tip: _data[a].tip, img: 'mebelvi/mebelViSlika1.jpg' })
          //}
          //console.log(a, _data.length - 1)
          //if (a == _data.length - 1) {
          //_that.navCtrl.push(ShowmorearticlesPage, { txt: _that.selectedEmplName, id: _that.selectedEmplIds, classobjs: _that.artClassObjs })
          _that.navCtrl.push(ShowmorearticlesPage, { txt: _that.selectedEmplName, id: _that.selectedEmplIds })
          //}
          //}
          //})


          // for (var i = 0; i < _that.gn.Articles.length; i++) {
          //   if ('11228' == _that.gn.Articles[i].articleidbyapi + '') {
          //     _that.gn.Articles[i].price = 10400
          //     _that.gn.Articles[i].img = 'mebelvi/mebelViSlika1.jpg'
          //     _that.artClassObjs.push(_that.gn.Articles[i])
          //   }
          //   if ('12700' == _that.gn.Articles[i].articleidbyapi + '') {
          //     _that.gn.Articles[i].price = 11900
          //     _that.gn.Articles[i].img = 'mebelvi/mebelViSlika2.jpg'
          //     _that.artClassObjs.push(_that.gn.Articles[i])
          //   }
          //   if ('12329' == _that.gn.Articles[i].articleidbyapi + '') {
          //     _that.gn.Articles[i].price = 9700
          //     _that.gn.Articles[i].img = 'mebelvi/mebelViSlika3.jpg'
          //     _that.artClassObjs.push(_that.gn.Articles[i])
          //   }
          //   if ('12004' == _that.gn.Articles[i].articleidbyapi + '') {
          //     _that.gn.Articles[i].img = 'mebelvi/mebelViSlika4.jpg'
          //     _that.gn.Articles[i].price = 12900
          //     _that.artClassObjs.push(_that.gn.Articles[i])
          //   }
          // }

          // console.log(_that.costsArray[parseInt(_ids+'')])
        }
      }, { cssClass: 'popover-content-articles1' });
      popover.present({ ev: _ev });
    }
  }

  openArticlePopup(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'Аrticles', selected: [], callback: function (_text, _ids) {
        _that.articleid = _ids
        _that.article = _text

        _that.gn._Post('/api/getmebelviarticle', { ident: _that.gn.crypt(_that.articleid), cid: _that.gn.crypt(_that.gn.user.ClientId), uid: _that.gn.crypt(_that.gn.user.UserId) }, function (_data) {
          _that.artObj = []
          _data[0].acDescr = (_data[0].acDescr).replace(/\n/g, "^~^");
          _data[0].acDescr = (_data[0].acDescr).replace(/\r/g, "");
          var k = _data[0].acDescr
          var karr = k.split('^~^')
          _that.artObj.push({ ident: _data[0].acIdent, name: _data[0].acName, descr: karr, price: _data[0].price, tip: _data[0].tip, img: 'mebelvi/mebelViSlika1.jpg' })
          _that.navCtrl.push(ShowonearticlePage, { txt: _that.article, id: _that.articleid, obj: _that.artObj[0] })
        })
        // for (var i = 0; i < _that.gn.Articles.length; i++) {
        //   if (_that.articleid + '' == _that.gn.Articles[i].id + '') {
        //     _that.gn.Articles[i].img = 'mebelvi/mebelViSlika.jpg'
        //     _that.gn.Articles[i].price = 17900
        //     _that.artObj = _that.gn.Articles[i]
        //   }
        // }
        // _that.navCtrl.push(ShowonearticlePage, { txt: _that.article, id: _that.articleid, obj: _that.artObj })
      }
    }, { cssClass: 'popover-content-articles1' });
    popover.present({ ev: _ev });
  }

}



// WEBPACK FOOTER //
// ./src/pages/mebelvisalon/searcharticles/searcharticles.ts